module.exports = __webpack_public_path__ + "img/GartenLunch.6cc0b22f.jpg";